import { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { getMappedLinkedItems } from './utils/component-mapping-helpers';

export const membership_configuration = (
  input: MEMBERSHIP_MODELS.MembershipConfiguration | undefined,
) => {
  if (!input || !input?.elements) {
    return undefined;
  }
  const restrictedContentPrompts = getMappedLinkedItems(
    input?.elements?.restricted_content_prompts,
  );

  return {
    restrictedContentPrompts,
  };
};

export default membership_configuration;
